import { $http, $httpPublic } from './http'
import { CardProviderEnum } from 'src/enums/CardProviderEnum'

const BASE_PATH = '/card/provider'
const BASE_PATH_ORDER = '/order/card'
const BASE_PATH_DEVICES = 'card-payment-devices'

class CardProviderService {
  getProviders = async () => {
    const result = await $http.get(BASE_PATH)
    return result.data
  }

  onCreateConnection = async (request: ICardProviderConnection) => {
    const result = await $http.post(BASE_PATH, request)
    return result.data
  }

  onDeleteConnection = async (providerType: number) => {
    const result = await $http.delete(BASE_PATH + '/' + providerType)
    return result.data
  }

  getCardProvider = async (providerType: number) => {
    const result = await $http.get(BASE_PATH + '/' + providerType)
    return result.data
  }

  onCreateLinkPayment = async (orderId: number) => {
    const result = await $http.post(BASE_PATH_ORDER + '/' + orderId)
    return result.data
  }

  getLinkPayment = async (order: string, uuid: string) => {
    const result = await $httpPublic.get(`${BASE_PATH_ORDER}/public/${order}/${uuid}`)
    return result.data
  }

  getVoucherByDocumentId = async (documentId: number) => {
    const result = await $http.get(`${BASE_PATH_ORDER}/${documentId}/voucher`)
    return result.data
  }

  getTermsConditions = async (providerId: number) => {
    const result = await $http.get(`${BASE_PATH}/${providerId}/termsConditions`)
    return result.data
  }

  getCardPaymentDevices = async (providerId: CardProviderEnum) => {
    const result = await $http.get(`${BASE_PATH_DEVICES}/${providerId}`)
    return result.data
  }

  createCardPaymentDevice = async (request: ICardProviderDeviceRequest) => {
    const result = await $http.post(`${BASE_PATH_DEVICES}`, request)
    return result.data
  }

  updateCardPaymentDevice = async (request: ICardProviderDeviceRequest) => {
    const result = await $http.put(`${BASE_PATH_DEVICES}/${request.id}`, request)
    return result.data
  }

  deleteCardPaymentDevice = async (deviceId: number) => {
    const result = await $http.delete(`${BASE_PATH_DEVICES}/${deviceId}`)
    return result.data
  }
}

export default new CardProviderService()
